module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-22.2abf62c6.png";